
import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class FarmaciaPopup extends Vue {
  showPopup = false;
  imagenSrc = require("@/assets/Web/farmacia-popup.jpg");

  @Watch("$route", { immediate: true })
  onRouteChange() {
    this.showPopup = this.$route.path === "/farmacia-municipal";
  }

  closePopup() {
    this.showPopup = false;
  }
}
